
import CarouselMulti from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ProductSlider from "../components/ProductSlider";
import VideoGrid from "../components/VideoGrid";
import VideoGridDesktop from "../components/VideoGridDesktop";
import useMediaQuery from "../hooks/useMediaQuery";

const Home = () => {
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };

    const responsiveSlider = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 2,
            slidesToSlide: 2
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };

    const isDesktop = useMediaQuery('(min-width:1280px)');
    console.log("isDesktop -- ", isDesktop);

    return (
        <>
            <CarouselMulti
                ssr
                deviceType="desktop"
                infinite={true}
                showDots={true}
                autoPlay={true}
                autoPlaySpeed={7000}
                responsive={responsive}
            >
                <div className="relative">
                    <Link to="/product/101">
                        <div className="lg:block hidden">
                            <img
                                className="object-cover object-bottom w-screen home-img"
                                src="/assets/static/images/Home-Carousel-01.jpg"
                                alt=""
                            />
                        </div>
                        <div className="lg:hidden portrait:hidden block">
                            <img
                                className="object-cover object-bottom w-screen home-img"
                                src="/assets/static/images/Home-Carousel-01.jpg"
                                alt=""
                            />
                        </div>
                        <div className="lg:hidden landscape:hidden block">
                            <img
                                className="object-fit object-bottom w-screen"
                                src="/assets/static/images/Home-Carousel-01-sm.jpg"
                                alt=""
                            />
                        </div>
                    </Link>
                </div>
                <div className="relative">
                    <Link to="/product/105">
                        <div className="lg:block hidden">
                            <img
                                className="object-cover object-bottom w-screen home-img"
                                src="/assets/static/images/Home-Carousel-02.jpg"
                                alt=""
                            />
                        </div>
                        <div className="lg:hidden portrait:hidden block">
                            <img
                                className="object-cover object-bottom w-screen home-img"
                                src="/assets/static/images/Home-Carousel-02.jpg"
                                alt=""
                            />
                        </div>
                        <div className="lg:hidden landscape:hidden block">
                            <img
                                className="object-fit object-bottom w-screen"
                                src="/assets/static/images/Home-Carousel-02-sm.jpg"
                                alt=""
                            />
                        </div>
                    </Link>
                </div>
                <div className="relative">
                    <Link to="/product/103">
                        <div className="lg:block hidden">
                            <img
                                className="object-cover object-bottom w-screen home-img"
                                src="/assets/static/images/Home-Carousel-03.jpg"
                                alt=""
                            />
                        </div>
                        <div className="lg:hidden portrait:hidden block">
                            <img
                                className="object-cover object-bottom w-screen home-img"
                                src="/assets/static/images/Home-Carousel-03.jpg"
                                alt=""
                            />
                        </div>
                        <div className="lg:hidden landscape:hidden block">
                            <img
                                className="object-fit object-bottom w-screen"
                                src="/assets/static/images/Home-Carousel-03-sm.jpg"
                                alt=""
                            />
                        </div>
                    </Link>
                </div>
            </CarouselMulti>

            <div className="flex lg:flex-row flex-col-reverse dinshaw-card--sm">
                <div className="lg:w-1/2">
                    <img className="object-cover lg:object-right w-screen card-img landscape:hidden"
                        src="/assets/static/images/Home-04.jpg"
                        alt=""
                    />
                     <img className="object-cover lg:object-right w-screen portrait:hidden"
                        src="/assets/static/images/Home-04.jpg"
                        alt=""
                    />
                </div>
                <div className="lg:w-1/2">
                    <div className="bg-dinshaw-secondary flex flex-col justify-center text-center items-center h-full w-full px-2 py-2 lg:py-8 lg:px-4 ">
                        <h2 data-aos="fade-up" className="text-dinshaw-yellow p-2">
                            Taste Of Quality In Every Bite <br />
                            WRAPPED IN LOVE
                        </h2>
                        <p data-aos="zoom-in" data-aos-duration="1200" className="text-white w-full sm:w-5/6 px-8 p-2 lg:p-4 leading-snug lg:leading-relaxed">
                            Every Dinshaw's product is made from the finest & purest of ingredients and passes through the most stringent of quality checks before it reaches you. Our every product is wrapped in a promise of taste, quality & integrity!
                        </p>
                    </div>
                </div>
            </div>
            <div className="dinshaw-card--sm">
                <div className='flex flex-col justify-center text-center items-center text-dinshaw-secondary px-4 lg:px-12 py-4 lg:py-12'>
                    <h2>Wide Range Of Smiles <br />
                        WRAPPED IN LOVE</h2>
                </div>

                <CarouselMulti
                    ssr
                    deviceType="desktop"
                    infinite={false}
                    responsive={responsiveSlider}
                >
                    <ProductSlider category="Bakery"></ProductSlider>
                    <ProductSlider category="Dairy"></ProductSlider>
                    <ProductSlider category="Ice Creams"></ProductSlider>
                    <ProductSlider category="Namkeen"></ProductSlider>
                </CarouselMulti>
            </div>


            <div className='relative flex flex-col justify-center text-center bg-dinshaw-theme items-center h-full w-full py-8 lg:py-28 px-4'>
                <h2 data-aos="fade-up" className="leading-snug text-dinshaw-yellow">
                    Story of Ethics, Excellence & Efficiency
                </h2>
                <div data-aos="zoom-in" data-aos-duration="1500" className="text-white w-full sm:w-5/6 lg:w-4/6 px-8 p-2 sm:p-4">
                    <p>In 1932, when refrigerators were still a novelty, Dinshaw’s launched handcrafted premium ice creams in India. Since then, we’ve crossed many milestones in our long journey so far, but we feel, we’ve just started!</p>
                    <p className="pt-4">Even today, we are an ardent believer that quality ranks above profit and natural beats preservatives. Our promise is to produce products that are delicious, healthy, pure and natural. We owe it to the community, our legacy and most importantly, to you.</p>
                </div>
            </div>

            {
                isDesktop ?
                    <VideoGridDesktop></VideoGridDesktop> : <VideoGrid></VideoGrid>
            }

            <div className="dinshaw-card--sm relative">
                <div className='flex flex-col justify-center text-center items-center h-full w-full pt-4 lg:pt-16 pb-8 px-8 lg:px-16'>
                    <h2 className="leading-snug text-dinshaw-red">
                        Know The News
                    </h2>
                    <p className="text-dinshaw-grey font--bold px-2 lg:px-4 w-5/6 lg:w-1/2 lg:leading-relaxed">
                        Know all the delicious news from behind the counter! Get first-hand insights on brand new flavours, products, partnerships and much more.
                    </p>
                </div>
                <div className="mb-4">
                    <CarouselMulti
                        ssr
                        deviceType="desktop"
                        infinite={false}
                        showDots={true}
                        responsive={responsiveSlider}
                    >
                        <LazyLoadImage
                            className="h-full object-cover w-full"
                            src="assets/static/images/Home page-09.jpg"
                            alt=""
                        />
                        <LazyLoadImage
                            className="h-full object-cover w-full"
                            src="assets/static/images/Home page-10.jpg"
                            alt=""
                        />
                    </CarouselMulti>
                </div>
            </div>

        </>
    );
};

export default Home;
